// API Configuration
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:7071';

// Service Types Configuration
export const serviceTypes = [
    // Fitness & Health
    { id: 'personal_training', name: 'Personal Training', category: 'fitness', icon: '🏋️', description: 'One-on-one fitness coaching' },
    { id: 'group_fitness', name: 'Group Fitness Classes', category: 'fitness', icon: '👥', description: 'Group workout sessions' },
    { id: 'nutrition_coaching', name: 'Nutrition Coaching', category: 'fitness', icon: '🥗', description: 'Diet and meal planning' },
    { id: 'meal_prep', name: 'Meal Prep Service', category: 'fitness', icon: '🍱', description: 'Prepared healthy meals' },
    { id: 'yoga_instruction', name: 'Yoga Instruction', category: 'fitness', icon: '🧘‍♀️', description: 'Yoga classes and poses' },
    { id: 'sports_coaching', name: 'Sports Coaching', category: 'fitness', icon: '⚽', description: 'Specific sport training' },

    // Business & Marketing
    { id: 'business_consulting', name: 'Business Consulting', category: 'business', icon: '💼', description: 'Strategic business advice' },
    { id: 'marketing_strategy', name: 'Marketing Strategy', category: 'business', icon: '📊', description: 'Marketing planning and execution' },
    { id: 'social_media_management', name: 'Social Media Management', category: 'business', icon: '📱', description: 'Social media content and strategy' },
    { id: 'brand_development', name: 'Brand Development', category: 'business', icon: '🎯', description: 'Brand identity and positioning' },
    { id: 'sales_coaching', name: 'Sales Coaching', category: 'business', icon: '💰', description: 'Sales skills and techniques' },
    { id: 'pitch_deck_review', name: 'Pitch Deck Review', category: 'business', icon: '🚀', description: 'Investor pitch preparation' },
    { id: 'financial_planning', name: 'Financial Planning', category: 'business', icon: '📈', description: 'Financial strategy and budgeting' },

    // Wellness & Mindfulness
    { id: 'life_coaching', name: 'Life Coaching', category: 'wellness', icon: '🌟', description: 'Personal development coaching' },
    { id: 'therapy_session', name: 'Therapy Session', category: 'wellness', icon: '🗣️', description: 'Mental health counseling' },
    { id: 'meditation_guidance', name: 'Meditation Guidance', category: 'wellness', icon: '🧘', description: 'Meditation techniques and practice' },
    { id: 'stress_management', name: 'Stress Management', category: 'wellness', icon: '😌', description: 'Stress reduction techniques' },
    { id: 'relationship_counseling', name: 'Relationship Counseling', category: 'wellness', icon: '💕', description: 'Couples and relationship advice' },
    { id: 'mindfulness_workshop', name: 'Mindfulness Workshop', category: 'wellness', icon: '🌱', description: 'Mindfulness practice sessions' },

    // Creative & Design
    { id: 'graphic_design', name: 'Graphic Design', category: 'creative', icon: '🎨', description: 'Visual design and branding' },
    { id: 'photography', name: 'Photography Session', category: 'creative', icon: '📸', description: 'Photo shoots and editing' },
    { id: 'video_production', name: 'Video Production', category: 'creative', icon: '🎬', description: 'Video creation and editing' },
    { id: 'content_creation', name: 'Content Creation', category: 'creative', icon: '✍️', description: 'Written and visual content' },
    { id: 'web_design', name: 'Web Design', category: 'creative', icon: '💻', description: 'Website design and development' },
    { id: 'illustration', name: 'Illustration', category: 'creative', icon: '🖌️', description: 'Custom artwork and illustrations' },

    // Education & Skills
    { id: 'tutoring', name: 'Tutoring', category: 'education', icon: '📚', description: 'Academic subject tutoring' },
    { id: 'language_lessons', name: 'Language Lessons', category: 'education', icon: '🗣️', description: 'Foreign language instruction' },
    { id: 'skill_workshop', name: 'Skill Workshop', category: 'education', icon: '🛠️', description: 'Professional skill development' },
    { id: 'career_coaching', name: 'Career Coaching', category: 'education', icon: '🎯', description: 'Career guidance and development' },
    { id: 'online_course', name: 'Online Course', category: 'education', icon: '💻', description: 'Structured learning programs' },
    { id: 'mentorship', name: 'Mentorship Program', category: 'education', icon: '👥', description: 'Long-term guidance and support' },

    // Lifestyle & Beauty
    { id: 'makeup_artistry', name: 'Makeup Artistry', category: 'lifestyle', icon: '💄', description: 'Makeup application and lessons' },
    { id: 'skincare_consultation', name: 'Skincare Consultation', category: 'lifestyle', icon: '✨', description: 'Personalized skincare advice' },
    { id: 'fashion_styling', name: 'Fashion Styling', category: 'lifestyle', icon: '👗', description: 'Personal style and wardrobe' },
    { id: 'hair_styling', name: 'Hair Styling', category: 'lifestyle', icon: '💇', description: 'Hair cutting and styling' },
    { id: 'lifestyle_coaching', name: 'Lifestyle Coaching', category: 'lifestyle', icon: '🌟', description: 'Overall lifestyle improvement' },
    { id: 'wardrobe_consultation', name: 'Wardrobe Consultation', category: 'lifestyle', icon: '👚', description: 'Closet organization and styling' },

    // Other/General
    { id: 'consultation', name: 'General Consultation', category: 'all', icon: '💬', description: 'General advice and consultation' },
    { id: 'custom_service', name: 'Custom Service', category: 'all', icon: '🔧', description: 'Customized service offering' }
];

// Categories Configuration
export const categories = [
    {
        id: 'all',
        name: 'All Categories - uncategorized',
        icon: '🌟',
        description: 'Discover all types of services',
        color: 'purple',
        userJourney: 'exploration'
    },
    {
        id: 'fitness',
        name: 'Fitness & Health',
        icon: '💪',
        description: 'Personal training, nutrition, wellness coaching',
        color: 'green',
        userJourney: 'transformation',
        trending: true
    },
    {
        id: 'business',
        name: 'Business & Marketing',
        icon: '💼',
        description: 'Consulting, strategy, growth, marketing expertise',
        color: 'blue',
        userJourney: 'growth'
    },
    {
        id: 'wellness',
        name: 'Wellness & Mindfulness',
        icon: '🧘',
        description: 'Mental health, meditation, life coaching',
        color: 'teal',
        userJourney: 'healing'
    },
    {
        id: 'creative',
        name: 'Creative & Design',
        icon: '🎨',
        description: 'Photography, design, content creation',
        color: 'pink',
        userJourney: 'expression'
    },
    {
        id: 'education',
        name: 'Education & Skills',
        icon: '📚',
        description: 'Learning, courses, skill development, mentoring',
        color: 'orange',
        userJourney: 'learning'
    },
    {
        id: 'lifestyle',
        name: 'Lifestyle & Beauty',
        icon: '✨',
        description: 'Beauty, fashion, lifestyle coaching',
        color: 'rose',
        userJourney: 'enhancement'
    }
];

// Regions Configuration
export const regions = [
    {
        id: 'all',
        name: 'All Regions',
        icon: '🌍',
        description: 'Global services from everywhere',
        timezone: 'All Timezones'
    },
    {
        id: 'north_america',
        name: 'North America',
        icon: '🇺🇸',
        description: 'United States, Canada, Mexico',
        timezone: 'EST/PST/CST/MST'
    },
    {
        id: 'europe',
        name: 'Europe',
        icon: '🇪🇺',
        description: 'European Union and surrounding countries',
        timezone: 'CET/GMT'
    },
    {
        id: 'asia',
        name: 'Asia Pacific',
        icon: '🌏',
        description: 'Asia Pacific region including Australia',
        timezone: 'JST/AEST/IST'
    },
    {
        id: 'south_america',
        name: 'South America',
        icon: '🇧🇷',
        description: 'South American countries',
        timezone: 'BRT/ART'
    },
    {
        id: 'other',
        name: 'Other Regions',
        icon: '🌎',
        description: 'Africa, Middle East, and other regions',
        timezone: 'Various'
    }
];

// Review Types Configuration
export const reviewTypes = [
    {
        id: 'all',
        name: 'All Reviews',
        icon: '🌟',
        description: 'Both services and sponsored content'
    },
    {
        id: 'service',
        name: 'Direct Services',
        icon: '💼',
        description: 'Coaching, consulting, and direct services'
    },
    {
        id: 'advertisement',
        name: 'Sponsored Content',
        icon: '📢',
        description: 'Product reviews and brand partnerships'
    }
];

// Mock Services Data
export const mockServices = [
    {
        id: 1,
        username: '@fitnessguru_sarah',
        name: 'Sarah Chen',
        category: 'fitness',
        region: 'north_america',
        title: 'Celebrity Personal Trainer & Nutrition Coach',
        description: 'Transform your body and mindset with proven fitness strategies used by Hollywood stars',
        avatar: '👩‍💼',
        followers: '2.8M',
        rating: 4.9,
        reviewCount: 2847,
        price: '$150/session',
        responseTime: '< 2 hours',
        completionRate: 98,
        languages: ['English', 'Mandarin'],
        availability: 'Mon-Fri, 6AM-8PM PST',
        verified: true,
        featured: true,
        badge: 'Top Rated Pro',
        specialties: ['Weight Loss', 'Muscle Building', 'Nutrition Planning'],
        serviceTypes: ['1-on-1 Coaching', 'Group Sessions', 'Meal Plans'],
        portfolioImages: ['💪', '🏋️', '🥗'],
        testimonials: [
            { text: 'Lost 30lbs in 3 months!', author: '@jenny_transforms', rating: 5 },
            { text: 'Best investment in my health', author: '@mike_fitness', rating: 5 }
        ],
        reviewTypes: {
            service: { count: 1923, rating: 4.9 },
            advertisement: { count: 924, rating: 4.8 }
        },
        socialProof: {
            totalClients: '5,000+',
            yearsExperience: 8,
            certifications: ['NASM', 'ACSM', 'Precision Nutrition']
        },
        recentActivity: {
            lastActive: '2 hours ago',
            responseRate: '99%',
            avgResponseTime: '45 minutes'
        }
    },
    {
        id: 2,
        username: '@business_mentor_alex',
        name: 'Alex Rodriguez',
        category: 'business',
        region: 'north_america',
        title: 'Ex-Goldman Sachs Business Strategy Consultant',
        description: 'Scale your startup from idea to IPO with battle-tested frameworks from Fortune 500 companies',
        avatar: '👨‍💼',
        followers: '1.2M',
        rating: 4.8,
        reviewCount: 1456,
        price: '$300/hour',
        responseTime: '< 1 hour',
        completionRate: 96,
        languages: ['English', 'Spanish'],
        availability: 'Mon-Sat, 9AM-6PM EST',
        verified: true,
        featured: true,
        badge: 'Business Expert',
        specialties: ['Growth Strategy', 'Fundraising', 'Market Analysis'],
        serviceTypes: ['Strategy Consulting', 'Pitch Deck Review', 'Due Diligence'],
        portfolioImages: ['📊', '💼', '🚀'],
        testimonials: [
            { text: 'Helped us raise $2M Series A', author: '@startup_founder', rating: 5 },
            { text: 'Incredible strategic insights', author: '@ceo_life', rating: 5 }
        ],
        reviewTypes: {
            service: { count: 987, rating: 4.9 },
            advertisement: { count: 469, rating: 4.7 }
        },
        socialProof: {
            totalClients: '300+',
            yearsExperience: 12,
            certifications: ['MBA Wharton', 'CFA', 'PMO']
        },
        recentActivity: {
            lastActive: '30 minutes ago',
            responseRate: '100%',
            avgResponseTime: '15 minutes'
        }
    },
    {
        id: 3,
        username: '@wellness_coach_maya',
        name: 'Maya Patel',
        category: 'wellness',
        region: 'asia',
        title: 'Mindfulness & Mental Health Therapist',
        description: 'Find inner peace and emotional balance through evidence-based mindfulness and therapy techniques',
        avatar: '🧘‍♀️',
        followers: '890K',
        rating: 4.9,
        reviewCount: 3421,
        price: '$80/session',
        responseTime: '< 3 hours',
        completionRate: 99,
        languages: ['English', 'Hindi', 'Japanese'],
        availability: '7 days/week, 6AM-10PM JST',
        verified: true,
        featured: false,
        badge: 'Wellness Expert',
        specialties: ['Anxiety Management', 'Meditation', 'Stress Relief'],
        serviceTypes: ['Individual Therapy', 'Group Sessions', 'Workshops'],
        portfolioImages: ['🧘', '🌸', '☮️'],
        testimonials: [
            { text: 'Life-changing therapy sessions', author: '@peaceful_mind', rating: 5 },
            { text: 'Amazing mindfulness techniques', author: '@zen_journey', rating: 5 }
        ],
        reviewTypes: {
            service: { count: 2987, rating: 4.9 },
            advertisement: { count: 434, rating: 4.8 }
        },
        socialProof: {
            totalClients: '2,000+',
            yearsExperience: 6,
            certifications: ['Licensed Therapist', 'Mindfulness-Based Stress Reduction', 'CBT']
        },
        recentActivity: {
            lastActive: '1 hour ago',
            responseRate: '98%',
            avgResponseTime: '1 hour'
        }
    }
];
